import { Button as Styledbutton } from "@fefyi/ui/button";
import type { ButtonProps } from "@fefyi/ui/button";
import { twMerge } from "tailwind-merge";

export const Wrapper = ({ children }: { children: React.ReactNode }) => (
  <div className="h-full w-full">
    <div className="grid h-full w-full grid-rows-[1fr_auto]">{children}</div>
  </div>
);

export const BottomBar = ({
  children,
  centered = false,
}: {
  children: React.ReactNode;
  centered?: boolean;
}) => (
  <footer className="self-end">
    <div
      className={twMerge(
        "border-white-opaque bg-white-opaque -mx-5 mt-5 -mb-5 grid grid-cols-[auto_1fr_auto] items-center gap-2 rounded-b-2xl border-t px-5 py-4 text-lg md:gap-4",
        centered && "justify-center",
      )}
    >
      {children}
    </div>
  </footer>
);

export const Button = ({ children, className, ...props }: ButtonProps) => (
  <Styledbutton
    intent="primary"
    className={twMerge(
      "bg-white-opaque border-white-opaque hover:bg-white-opaque-dark focus-visible:bg-white-opaque-dark border",
      className,
    )}
    {...props}
  >
    {children}
  </Styledbutton>
);
